function FormHead({patient_name}) {
    // bg-[#ccc]
    return (
        <>
        {/* <div className=" flex pb-5 justify-center w-4/5 text-xl text-center m-auto"> */}
            <td>
                <label>病人姓名&nbsp;&nbsp;&nbsp;&nbsp;</label>
                <input id="patient_name" value={patient_name} disabled="true" style={{outline: "solid 1px gray", borderRadius:"0.25em", outlineColor: "rgba(118, 118, 118, 0.3)"}} className="pl-2"></input>
            </td>
            <td>
                <label>&nbsp;&nbsp;&nbsp;&nbsp;填寫者姓名&nbsp;&nbsp;&nbsp;&nbsp;</label>
                <input id="recorder_name" value="信賴眼科診所" disabled="true" style={{outline: "solid 1px gray", borderRadius:"0.25rem", outlineColor: "rgba(118, 118, 118, 0.3)"}} className="pl-2"></input>
            </td>
        {/* </div> */}
        </>
    )
}

export default FormHead;